// let download = "https://uat.yoozworld.cn/";
let download = 'https://om.yoozworld.cn/';  //正式环境"
export {download}